import { GLView } from 'expo';
import * as React from 'react';
import { Text, TouchableWithoutFeedback, View, Button } from 'react-native';

import DisableBodyScrollingView from './components/DisableBodyScrollingView';
import ExpoButton from './components/ExpoButton';
import GithubButton from './components/GithubButton';
import KeyboardControlsView from './components/KeyboardControlsView';
import logo from './assets/icons/app_logo.png';
import Game from './src/game';
import './styles.css'

export default class App extends React.Component {
  state = {
    score: 0,
    displayMobile: true,
  };
  render() {
    const { style, ...props } = this.props;
    return (
      <View className="holding-page">
        <View className='wcw-desktop-header'>
          <img className="wcw-desktop-logo" src={logo} />
          <Text className="wcw-desktop-text"> Coming 2022</Text>
        </View>
        <View className="content-page">
          {this.state.displayMobile?
          <View className="mobile-modal">
            <View className="modal-body"> 
              <img className="wcw-mobile-logo" src={logo} />
              <Text className="wcw-text"> Coming 2022</Text>
              <Button className="wcw-button" title="PLAY" onPress={()=> this.setState({displayMobile: false})} />
            </View>
          </View>:
          <View></View>
          }
          <DisableBodyScrollingView>
            <KeyboardControlsView
              onKeyDown={({ code }) => {
                if (this.game) {
                  if (code === 'Space') {
                    this.game.onPress();
                  }
                }
              }}
            >
              <TouchableWithoutFeedback
                onPressIn={() => {
                  if (this.game) this.game.onPress();
                }}
              >
                <GLView
                  style={{ flex: 1, backgroundColor: 'black' }}
                  onContextCreate={context => {
                    this.game = new Game(context);
                    this.game.onScore = score => this.setState({ score });
                  }}
                />
              </TouchableWithoutFeedback>

              <Score>{this.state.score}</Score>
            </KeyboardControlsView>
          </DisableBodyScrollingView>
          <ExpoButton />
          <GithubButton />
        </View>
      </View>
    );
  }
}

const Score = ({ children }) => (
  <Text
    style={{
      position: 'absolute',
      left: 0,
      top: '10%',
      right: 0,
      textAlign: 'center',
      color: 'white',
      fontSize: 48,
      userSelect: 'none',
    }}
  >
    {children}
  </Text>
);
